import Goals from './components/Goals';

export default Goals;
